import { useLocation, useNavigate } from 'react-router-dom';

export const useQueryParams = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const getQueryParams = (): URLSearchParams => {
    return new URLSearchParams(location.search);
  };

  const setQueryParams = (params: Record<string, any>) => {
    const query = new URLSearchParams(location.search);

    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        const val = typeof value === 'string' ? value : JSON.stringify(value);
        query.set(key, val);
      } else {
        query.delete(key);
      }
    });

    navigate({ search: query.toString() }, { replace: true });
  };

  return { getQueryParams, setQueryParams };
};
